// extracted by mini-css-extract-plugin
export default {"wrapper":"_5Hmiz","container":"hAdO+","buttonsContainer":"NLsGM","confirmModalButton":"WfAnA","cancelButton":"bYIr4"};